var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "image-cta-large",
    {
      attrs: {
        "body-html": _vm.subHeader,
        "button-text": _vm.buttonText,
        "button-link": _vm.buttonLink,
        version: _vm.widgetOption,
      },
    },
    [
      _vm._t("default", function () {
        return [_vm._v("Explore electric vehicles")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }